import { connect } from "react-redux";
import NavHandle from "./";

import { getNavSection } from "../../state/navSection";

const withRedux = connect(
  state => ({
    navSection: getNavSection(state)
  }),
  () => ({})
);

export default withRedux(NavHandle);



// WEBPACK FOOTER //
// ./src/components/NavHandle/container.js